import {addFloorPlan} from "./src/mixins/addFloorPlan";

require('./bootstrap');
import Vue from "vue"
import App from "./App.vue"

// Vue Router
import Router from "vue-router";
Vue.use(Router);

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        el.removeEventListener('scroll', f)
      }
    }
    el.addEventListener('scroll', f)
  }
})

import router from './src/router'

import {pluralOfNum} from './src/mixins/pluralOfNum';
import {getFloorImageUrl} from "./src/mixins/getFloorImageUrl";

Vue.mixin(pluralOfNum);
Vue.mixin(addFloorPlan);
Vue.mixin(getFloorImageUrl);

new Vue({
    el: '#app',
    router,
    render: h => h(App)
});
